<template>
  <div class="row">
    <el-container>
      <el-aside width="200px">
        <el-menu :default-openeds="['1','2']">
          <el-submenu index="1">
            <template slot="title">行政许可办事指南</template>
            <el-menu-item><router-link tag='div' to='/hyjdMsg/pipedepartment' index='1-1'>运管局许可</router-link></el-menu-item>
            <el-menu-item><router-link tag='div' to='/hyjdMsg/roaddepartment' index='1-2'>公路管理局许可</router-link></el-menu-item>
            <el-menu-item><router-link tag='div' to='/hyjdMsg/maritimrdepartment' index='1-3'>海事局许可</router-link></el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">行业企业信息</template>
            <el-menu-item><router-link tag='div' to='/hyjdMsg/taxiTraffic' index='2-1'>出租企业</router-link></el-menu-item>
            <el-menu-item><router-link tag='div' to='/hyjdMsg/busTraffic' index='2-2'>客运企业</router-link></el-menu-item>
            <el-menu-item><router-link tag='div' to='/hyjdMsg/dangerTraffic' index='2-3'>危货企业</router-link></el-menu-item>
            <el-menu-item><router-link tag='div' to='/hyjdMsg/normalTraffic' index='2-3'>普货企业</router-link></el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main style>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "hyjdmsg",
  data() {
    return {
    };
  },
  
};
</script>
<style scoped>
.el-container {
  height:700px;
  width: 100%;
}
.el-aside {
  background-color: #f3f4f5;
  overflow: hidden;
  margin-right: 5px;
}
.el-menu,.el-menu-item {
  /* padding: 0; */
  background-color: #f3f4f5;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px dashed #ccc;
  /* text-align: center; */
}
.el-menu-item div{
  text-align: center;
  /* border:1px solid red; */
}
.el-main {
  padding: 0;
}
/* .is-active{
  background: red;
} */
.router-link-active{
   /* background-color: rgba(1, 152, 251, 1); */
  color: rgba(1, 152, 251, 1);;
}
</style>


// WEBPACK FOOTER //
// src/pages/hyjdmsg/index.vue